import DepartmentsModel from '../Apis/Departments'
import Controller from './Controller'

export default class DepartmentsController extends Controller {
  constructor() {
    super(new DepartmentsModel())
  }
}
